<template>
    <header class="page-header">
        <div v-if="preview" style="position: absolute;
                    left: 50%;
                    top: 30px;
                    border: 2px solid red;
                    padding: 4px 16px;
                    border-radius: 8px;
                ">
            <span>is preview: {{preview}}</span><a style="margin-left: 16px; cursor: pointer;" @click.prevent="disablePreview">X</a></div>
        <div class="page-header-bg" id="pageHeaderBgJS"></div>
        <div class="page-header__wrapper">
            <div class="page-header__left-container">
                <router-link class="logo" :to="{ name : 'home' }"><img src="../assets/images/logo.png" width="158" height="25" alt="AirEuropa Logo2"></router-link>
                <span class="site-title">{{$t('title1')}}<br>{{$t('title2')}}<br>{{$t('title3')}}</span>
            </div>


            <div class="page-header__right-container">
                <div class="site-lang-back" role="button" >
                    <a @click.prevent="scrollToTop()" href="#">{{$t('back_to_top')}} <font-awesome-icon :icon="['fas', 'arrow-circle-up']" /> </a>
                </div>

                <div class="site-lang" role="button" v-if="lang === 'en'">
                    <a @click.prevent="changeLanguage('en')" :class="{ 'site-lang_en': true, 'active' : lang === 'en'}" href="#">English</a>
                    <a @click.prevent="changeLanguage('es')" :class="{ 'site-lang_es': true, 'active' : this.lang === 'es'}" href="#">Español</a>
                </div>
                <div class="site-lang" role="button" v-else-if="lang === 'es'">
                    <a @click.prevent="changeLanguage('es')" :class="{ 'site-lang_es': true, 'active' : lang === 'es'}" href="#">Español</a>
                    <a @click.prevent="changeLanguage('en')" :class="{ 'site-lang_en': true, 'active' : lang === 'en'}" href="#">English</a>
                </div>
                <div class="menu-icon" role="button" id="menuIcon">
                    <div class="menu-icon__line menu-icon__line-1"></div>
                    <div class="menu-icon__line menu-icon__line-2"></div>
                    <div class="menu-icon__line menu-icon__line-3"></div>
                </div>
            </div>
        </div>
        <div style="display: none">
            <img class="preloader-desktop" src="../assets/images/2preloader1228x492.gif">
            <img class="preloader-mobile" src="../assets/images/preloader350x534.gif">
            <img class="preloader-movie"src="../assets/images/preloader493x753.gif">
            <img class="preloader-music" src="../assets/images/preloader493x493.gif">
            <img class="preloader-game" src="../assets/images/preloader493x361.gif">
        </div>
    </header>
</template>

<script>
    import {i18n} from '../plugins/i18n';
    import { scrollDisable, scrollEnable, navPos, headerOpacityScroll } from '../outer-js'
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    export default {
        name: "PageHeader",
        computed:{
            ...mapGetters({
                lang: 'getLang',
                showMenu: 'getAside',
                preview: 'getPreview',
            })
        },
        mounted(){
            this.setLocale('es');
            $('#menuIcon').click(function () {
                event.preventDefault();
                var asideMenu = $('#asideMenuJS');
                if ($(this).hasClass('active')) {
                    scrollEnable();
                    $(this).removeClass('active');
                    asideMenu.fadeOut();
                } else {
                    $(this).addClass('active');
                    scrollDisable();
                    asideMenu.fadeIn();
                    window.dispatchEvent(new Event('resize'));
                }
            });
            $(window).scroll(function () {
                headerOpacityScroll();
            });
            $(window).resize(function () {
                headerOpacityScroll();
                navPos();
            });
            headerOpacityScroll();
        },
        methods: {
            ...mapActions({
                setLocale: 'setLocaleAsync',
                setAside: 'setAsideShow',
            }),
            scrollToTop(){
                $('html, body').animate({scrollTop:0}, 'slow');
            },
            changeLanguage(lang){
                i18n.locale = lang;
                this.setLocale(lang);
            },
            disablePreview(){
                window.location.href = "/";
            },
        }
    }
</script>

<style scoped>

</style>
